export default __webpack_public_path__ + "static/media/24.c4d8b2f8.jpeg";